module.exports = __webpack_public_path__ + "static/media/layout-1.abc3d744.jpg";